module.exports = __webpack_public_path__ + "components/MapControl/svg/Kościół zabytkowy.svg?4cc3abc2";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Kościół zabytkowy.svg
// module id = 2052
// module chunks = 0